import { Svg, Line } from "@react-pdf/renderer";
import { PDFStyleConfigs } from "../../configs";

export const HorizontalLine = ({
  width = PDFStyleConfigs.TableWidth,
  strokeWidth = 1,
  color = "#25324B",
}: {
  width?: number;
  strokeWidth?: number;
  color?: string;
}) => {
  return (
    <Svg height="10" width={width}>
      <Line
        x1={"0"}
        y1={"5"}
        x2={"100%"}
        y2={"5"}
        strokeWidth={strokeWidth}
        stroke={color}
      />
    </Svg>
  );
};
